<bgo-pro-directory
  [filter]="{offeringIds, region: region()}"
  [title]="title"
  (searchEnd)="total = $event.total"
  class="h-layout"
  *transloco="let t"
>
  <p role="heading" aria-level="2" content="heading">
    <span class="plot-lg text-president-500">
      {{ t('proDirectoryByOffering.resultTitle', {amount: total}) }}
    </span>
    @if (offeringNames.length) {
      <span class="heading-lg text-president-200"> "{{ offeringNames.join(', ') }}" </span>
    }
  </p>
</bgo-pro-directory>
